var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUidoLoad4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 333,
    viewBox: "0 0 235 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.111 99.8101C159.811 99.8101 188.911 122.2 193.701 139.79C198.731 158.28 162.611 170.65 119.221 179.35L115.361 179.88C12.1114 199.15 2.85136 237.76 15.4714 269.51",
    stroke: "#CC4429",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.433 330.72C94.633 330.72 76.723 324.75 76.153 315.95C75.663 308.3 89.673 299.66 118.493 296.08H119.223C189.983 284.75 230.513 257.18 232.883 208.92",
    stroke: "#CC4429",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.102 155.97C216.102 155.97 242.552 189.16 216.942 208.36C191.342 227.56 152.422 235.82 89.9316 251.82C50.0116 263.11 33.5016 290.56 46.4716 306.74",
    stroke: "#CC4429",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.192 103.08C146.192 103.08 170.782 107.8 160.852 115.88C152.762 122.28 121.262 129.36 85.0518 138.45C48.8418 147.54 -0.358188 164.9 1.66181 216.11",
    stroke: "#CC4429",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUidoLoad4);
export default __webpack_public_path__ + "static/media/uido_load_4.6189c28556b2e86432f72aeb4507640f.svg";
export { ForwardRef as ReactComponent };